<script setup lang="ts">
import { computed } from 'vue';
import Modal from '../Modal.vue';

const props = defineProps<{
  show: boolean;
  message: string;
  onSend: () => void;
}>();

const emit = defineEmits<{
  close: [];
}>();

// Format message to underline material
const formattedMessage = computed(() => {
  return props.message.replace(/^(.*?):/gm, (match) => {
    // Skip the "Sucursal:" line
    if (match.includes('Sucursal:')) return match;
    // Skip lines starting with "Trabajo"
    if (match.includes('Trabajo')) return match;
    // Underline other matches (materials)
    return `_${match}_`;
  });
});
</script>

<template>
  <Modal
    :show="show"
    title="Vista Previa del Pedido"
    @close="emit('close')"
  >
    <div class="space-y-6">
      <!-- Preview message -->
      <div class="bg-[#DCF8C6] rounded-lg p-4">
        <div class="whitespace-pre-wrap text-sm font-mono">{{ formattedMessage }}</div>
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4">
        <button
          type="button"
          @click="emit('close')"
          class="px-4 py-2 text-slate-600 hover:text-slate-800 font-medium"
        >
          Volver
        </button>
        <button
          type="button"
          @click="onSend"
          class="px-4 py-2 bg-[#25D366] text-white rounded-lg hover:bg-[#128C7E] transition-colors font-medium"
        >
          Enviar Pedido por WhatsApp
        </button>
      </div>
    </div>
  </Modal>
</template>